import {
    ASYNC_FETCH_RP_Confirm,
    ASYNC_FETCH_SUCCESS_RP_Confirm,
    ASYNC_FETCH_FAILURE_RP_Confirm,
  ASYNC_FETCH_INVALIDATE_RP_Confirm,
  SET_ISCONFIRM_LOAD
  } from '../constants';
  
import { updateObject } from '../../shared/utilities/reducer';
import common from '../../shared/utilities/common';

const initialState = {
  isFetching: true,
  statusCode: "",
  statusMessage: "",
  errorMessage: '',
  errorDesc: '',
  actionName: '',
  actionValue: '',
  errorObj: {},
  pageData: "",
  isConfirmLoad: false
}



export const asyncFetch = (state, action) => {
  console.log("getSectionsBegin called")
  return updateObject(state, {
    isFetching: true
  });
};

export const asyncFetchSuccess = (state, action) => {
  return updateObject(state, {
    isFetching: false,
    statusCode: action.msResp.responseInfo.responseCode,
    statusMessage: action.msResp.responseInfo.responseMessage,
    errorMessage: common.isError(action.msResp.responseInfo.responseCode, action.msResp.responseInfo.responseMessage, action.msResp.body),
    errorDesc: common.isErrorDesc(action.msResp.responseInfo.responseCode, action.msResp.responseInfo.responseMessage, action.msResp.body),
    actionName: common.isActionName(action.msResp.responseInfo.responseCode, action.msResp.responseInfo.responseMessage, action.msResp.body),
    actionValue: common.isActionValue(action.msResp.responseInfo.responseCode, action.msResp.responseInfo.responseMessage, action.msResp.body),
    errorObj: action.msResp.responseInfo.responseCode !== "00" && action.msResp.responseInfo ? action.msResp.responseInfo.sectionErrors : null,
    pageData: action.msResp.body
  });
};

export const asyncFetchFailed = (state, action) => {

  //Dont Delete this code untill implementing code to handel 500 status code error
  let msResp = action && action.err && action.err.response && action.err.response.data;
  let responseCode = msResp && msResp.responseInfo && msResp.responseInfo.responseCode;
  let responseMessage = msResp && msResp.responseInfo && msResp.responseInfo.responseMessage;
  let body = msResp && msResp.body;
  return updateObject(state, {
    isFetching: false,
    pageData: {},
    statusCode: responseCode ? responseCode : '',
    errorMessage: common.isError(responseCode, responseMessage, body),
    errorDesc: common.isErrorDesc(responseCode, responseMessage, body),
    actionName: common.isActionName(responseCode, responseMessage, body),
    actionValue: common.isActionValue(responseCode, responseMessage, body),
    errorObj: responseCode !== "00" && msResp && msResp.responseInfo ? msResp.responseInfo.sectionErrors : action.err,
  });
};

export const setisConfirmLoadValue = (state, action) => {
  return updateObject(state, {
    isConfirmLoad: action.data
  });
};

export const RpConfirmationPageReducer = (state = initialState, action) => {

  const { type } = action;
  switch (type) {
    case ASYNC_FETCH_RP_Confirm:
      return asyncFetch(state, action);
    case ASYNC_FETCH_SUCCESS_RP_Confirm:
      return asyncFetchSuccess(state, action);
    case ASYNC_FETCH_FAILURE_RP_Confirm:
      return asyncFetchFailed(state, action);
    case SET_ISCONFIRM_LOAD:
      return setisConfirmLoadValue(state, action);
    // case ASYNC_FETCH_INVALIDATE_RP_Confirm:
    //   return Object.assign({}, state, { isFetching: false, pageData: {} });
    default:
      return state;
  }
};
  